import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { supabase } from '../supabase/client'
import IPRChecklist from './IPRChecklist'
import './IPRChecklistPage.css'

const IPRChecklistPage = () => {
  const { userId, talentId } = useParams()
  const navigate = useNavigate()
  const [talentName, setTalentName] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [progress, setProgress] = useState(0)

  // Загрузка информации о таланте
  useEffect(() => {
    const fetchTalentData = async () => {
      try {
        setLoading(true)

        // Загружаем профиль, чтобы получить информацию о таланте
        const { data, error } = await supabase
          .from('ipr_profiles')
          .select('*')
          .eq('userId', userId)
          .single()

        if (error) {
          console.error('Error fetching profile:', error)
          throw error
        }

        const talents = JSON.parse(data.profileData).talents
        // Находим информацию о нужном таланте
        const talent = talents.find((t) => t.id === Number(talentId))

        if (!talent) {
          throw new Error(`Талант с ID ${talentId} не найден`)
        }

        setTalentName(talent.name)
      } catch (err) {
        console.error('Ошибка при загрузке данных таланта:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    if (userId && talentId) {
      fetchTalentData()
    }
  }, [userId, talentId])

  // Обработчик обновления прогресса
  const handleProgressUpdate = (talentId, newProgress) => {
    setProgress(newProgress)
  }

  // Обработчик возврата к профилю
  const handleBackToProfile = () => {
    navigate(`/profile/${userId}`)
  }

  if (loading) {
    return (
      <div className="checklist-page-container">
        <div className="checklist-page-loading">
          <div className="loader"></div>
          <p>Загрузка плана развития...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="checklist-page-container">
        <div className="checklist-page-error">
          <h2>Ошибка при загрузке плана развития</h2>
          <p>{error}</p>
          <button className="btn-primary" onClick={handleBackToProfile}>
            Вернуться к профилю
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="checklist-page-container">
      <div className="checklist-page-header">
        <button className="btn-back" onClick={handleBackToProfile}>
          <i className="fas fa-arrow-left"></i> Вернуться к профилю
        </button>
        <h1>План развития таланта: {talentName}</h1>
        <div className="checklist-progress">
          Выполнено: <span className="progress-value">{progress}%</span>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      </div>

      <div className="checklist-page-content">
        <IPRChecklist
          userId={userId}
          talentId={Number(talentId)}
          talentName={talentName}
          onProgressUpdate={handleProgressUpdate}
          compact={false} // Полный режим для отдельной страницы
        />
      </div>
    </div>
  )
}

export default IPRChecklistPage
